import {
  AlternativeDates,
  HotelProperties,
  RibbonError
} from "@beds2b-group/reusable-components/dist/types";
import { AlternativeDay, Hotel, } from "../models/availability/Commons";
import {
  AvailabilityType,
  LocationAvailability,
  LocationAvailabilityResponse,
  Restrictions,
} from "../models/availability/LocationsAvailability";
import { HotelCard } from "@beds2b-group/reusable-components";
import { EngineDestinationTypeHotel } from "./constants";
import { HotelLinkInfo, ServiceDto } from "../models/AppConfig";


const Link = ({ handleClick, to, children, className }: any) => {
  return (
    <button className={className} onClick={handleClick}>
      <a href={to}>{children}</a>
    </button>
  )
}

export function LocationToAppAvailability(
  locationAvailability: LocationAvailabilityResponse,
  bookingEngineContext: any,
  modal: any,
  hotels: HotelLinkInfo[],
  userCurrency: string,
  doExchangeCurrency: (fromCurrency: string, toCurrency: string, amount: number) => number,
  allServices: ServiceDto[],
  language: string,
  clientName: string
): JSX.Element[] {
  let result: JSX.Element[] = [];

  const isPortobay = clientName.toLowerCase().includes("portobay"); // si es portobay, entonces no mostramos hoteles sin  mapeo
  locationAvailability.locationAvailabilities?.forEach(
    (availability: LocationAvailability, index: number) => {

      let hotelData: Hotel | undefined = locationAvailability.hotels.find(
        (h) => {
          return h.code == availability.hotelCode;
        }
      );

      const staticHotelData = hotelData?.hotelStaticData?.find(
        (s) => s.languageIsoCode?.slice(0, 2).toLowerCase() === language.slice(0, 2).toLowerCase()
      ) ?? hotelData?.hotelStaticData?.[0];



      if (hotelData) {
        if (isPortobay) {  // si es portobay y no tiene mapeo, entonces no lo mostramos
          // si el hotel no existe en el mapeo original
          const mappedHotel = hotels.find(h => h.integrationCode === hotelData?.code);

          if (!mappedHotel) {
        //    console.warn("Hotel omitido por no estar mapeado:", hotelData.code);
            return;
          }
        }





        let hotelImages: string[] =
          staticHotelData?.images?.length
            ? staticHotelData.images
              .sort((i1: any, i2: any) => (i1.order ?? 0) - (i2.order ?? 0))
              .map(
                (image: any) =>
                  image?.url?.trim() ||
                  "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg"
              )
            : ["https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg"];



        let alternativeDates: Array<AlternativeDates> = [];
        if (availability.alternativeDays) {
          availability.alternativeDays.forEach(
            (alternativeDay: AlternativeDay) => {
              let alternativeDate: AlternativeDates = {
                from: new Date(alternativeDay.AccommodationDates.From),
                to: new Date(alternativeDay.AccommodationDates.To),
                price: {
                  currency: userCurrency,
                  amount: Number(
                    doExchangeCurrency(
                      alternativeDay.MinimalPrice.currencyIsoCode,
                      userCurrency,
                      alternativeDay.MinimalPrice.amount
                    ).toFixed(2)
                  ),
                },
              };

              alternativeDates.push(alternativeDate);
            }
          );
        }

        let servicesHotelId = hotels.find(h => h.integrationCode === hotelData?.code)?.servicesAvailable ?? [];
        let servicesInfo = allServices.filter(s => servicesHotelId.includes(s.id));


        let services: Array<{ icon: string, name: string }> = servicesInfo.map(s => {
          const translatedName = s.name.find(n => n.language.slice(0, 2).toLowerCase() === language.slice(0, 2).toLowerCase())?.value || "";
          return {
            icon: s.icon,
            name: translatedName
          };
        });


        let currencyCode = availability?.minimumPrice?.currencyIsoCode ?? userCurrency;
        let amount = availability?.minimumPrice?.amount ?? 0;

        if (currencyCode && currencyCode !== userCurrency) {
          amount = doExchangeCurrency(currencyCode, userCurrency, amount);
          currencyCode = userCurrency;
        }
        var hotelName = hotels.find((h) => h.code == availability.hotelCode)?.name;

        let hotel: HotelProperties = {
          code: hotelData?.code ?? "",
          images: hotelImages.length > 0 ? hotelImages : [],

          starts: Number.parseInt(hotelData?.category ?? "0"),
          services: services,
          shortDescription: staticHotelData?.shortDescription ?? "SD N/D ",
          alternativeDays: alternativeDates,
          price: {
            currency: currencyCode ?? "N/D",
            amount: Number.parseFloat(amount?.toFixed(2) ?? "0"),
          },
          description: staticHotelData?.largeDescription ?? "LD ND",
          address: {
            city: hotelData?.address.cityName ?? "",
            country: hotelData?.address.countryName ?? "",
            geoLocation: {
              latitude: hotelData?.address.latitude ?? 0,
              longitude: hotelData?.address.longitude ?? 0,
            },
            line1: hotelData?.address.streetName ?? "",
            zipCode: "ZC N/D (11)",
          },
          name: hotelName ?? hotelData.name ?? "Hotel N/D",
        };
        console.log("Los días alternativos de ", hotel.name, alternativeDates);

        let hotelError: RibbonError | undefined = undefined;
        if (availability.availabilityType) {
          let type: string = "";

          switch (availability.availabilityType as AvailabilityType) {
            case AvailabilityType.HasAvailability:
              // Tiene dispo, así que no hay problema.
              break;
            case AvailabilityType.NoAvailabilityHotelClosed:
              hotelError = {
                code: "HotelClosed",
                translation:
                  language == "es" ? "El hotel se encuentra cerrado en las fechas indicadas" : "The hotel is closed on the selected dates",
                classes: ["ribbon-error"],
                type: "error",
              };
              break;
            case AvailabilityType.NoAvailabilityNoquota:
              hotelError = {
                code: "HotelNoquota",
                translation:
                  language == "es" ? "El hotel no dispone de cupo para las fechas indicadas" : "The hotel has no availability for the selected dates",

                classes: ["ribbon-error"],
                type: "error",
              };
              break;
            case AvailabilityType.NoAvailabilityExistingRestrictions:
              let text: string = "";
              availability.restrictions.forEach((restriction) => {
                switch (restriction) {
                  case Restrictions.MinLos:
                    text = text + language == "es" ? "El hotel tiene una estancia mínima de xxx noches" : "The hotel has a minimum stay of xxx nights";
                    break;
                  case Restrictions.MaxLos:
                    text = text + language == "es" ? "El hotel tiene una estancia máxima de xxx noches" : "The hotel has a maximum stay of xxx nights";
                    break;
                  case Restrictions.Release:
                    text = text + language == "es" ? "El hotel tiene una release de xxx noches" : "The hotel has a release of xxx nights";
                    break;
                  case Restrictions.Unknow:
                    text = text + language == "es" ? "Existe una restricción no especificada en el sistema." : "There is an unspecified restriction in the system.";
                    break;
                }
              });

              hotelError = {
                code: "HotelRestrictions",
                translation: text,
                classes: ["ribbon-warning"],
                type: "warning",
              };

              break;

            default:
              break;
          }
        }


        result.push(
          <HotelCard
            key={index}
            Link={Link}
            handleBooking={async (data: any) => {
              let newContext = {
                searchType: EngineDestinationTypeHotel,
                searchCode: data.hotel.code,
                promotionalCode: bookingEngineContext.promotionalCode,
                label: data.hotel.name,
                dates: bookingEngineContext.dates,
                rooms: bookingEngineContext.rooms,
              };
              bookingEngineContext.updateContext(newContext);

              return new Promise((res) => null);
            }}
            routes={{
              alternativeDates: "",
              booking: "",
            }}
            hotel={hotel}
            showImagesModal={(props: any) => {
              const clonedHotel = JSON.parse(JSON.stringify(hotel));
              modal.show("hotel-modal", clonedHotel);
            }}

            error={hotelError}
          />
        );
      }
    }
  );

  return result;
}
